import React from 'react';
import { useSelector } from 'react-redux';
import CartIconByRydens from './Icons/Cart';

const MiniCart = () => {

    const { quantity, checkoutUrl } = useSelector(
        (state) => state.cart
    );
    return (
        <div className="cart cart--mini fgdfg">
            <a
                className="cart__link--block"
                rel="nofollow"
                href={checkoutUrl}

            >
                <span className="cart__quantity">{quantity}</span>
                <CartIconByRydens />
            </a>

        </div>
    );
};

export default MiniCart;
